export default "__VITE_ASSET__DHgAmn3t__"